export default {

  async getProduct ({ commit }, id) {
    const locale = this.$i18n.locale
    const response = await this.$axios.get(`/public/catalog/get/${id}?storeCode=${locale}`)
    commit('setProduct', response.data)
    return response
  },
  async getCheckedProduct ({ commit }, {
    entityId,
    currentPrice
  }) {
    const url = `/public/catalog/checked-get/${entityId}?currentPrice=${currentPrice}`

    const response = await this.$axios.get(url, { withCredentials: true })

    if (response.data?.auction?.auctionId) {
      commit('setProduct', response.data)
    } else {
      // console.log('price did not change ... not updating')
    }

    return response
  },
  async getTranslatedDescription ({ commit }, {
    entityId,
    storeCode,
    description
  }) {
    if (description) {
      try {
        const { data } = await this.$axios.get(`/public/translate/description/${entityId}?storeCode=${storeCode}`)
        commit('setTranslatedDescription', data)
        return data
      } catch (error) {
        console.error(error)
        return null
      }
    }
  },
  async getTranslatedDefectsDescription ({ commit }, {
    entityId,
    storeCode,
    description
  }) {
    if (description) {
      try {
        const { data } = await this.$axios.get(`/public/translate/defects-description/${entityId}?storeCode=${storeCode}`)

        commit('setTranslatedDefectsDescription', data)
        return data
      } catch (error) {
        console.error(error)
        return null
      }
    }
  },

  addToWatchList ({ commit }) {
    commit('addToWatchList')
  },

  removeFromWatchList ({ commit }) {
    commit('removeFromWatchList')
  },

  setAuctionEndingAt ({ commit }, endingAt) {
    commit('setAuctionEndingAt', endingAt)
  }

}
